// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ButtonsPage-cls1___538a73d016842493e9d{/*!*/}.ButtonsPage-cls2___d853d7541be0432dc94{}.ButtonsPage-cls2___d853d7541be0432dc94.ButtonsPage-withThumbnail__c421256e3c839d809b34{padding-bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ButtonsPage-cls1___538a73d016842493e9d",
	"cls2": "ButtonsPage-cls2___d853d7541be0432dc94 ButtonsPage-cls1___538a73d016842493e9d",
	"withThumbnail": "ButtonsPage-withThumbnail__c421256e3c839d809b34"
};
export default ___CSS_LOADER_EXPORT___;
